var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.5 72.6858C87.5 74.4048 86.7817 76.0534 85.503 77.2689C84.2243 78.4844 82.4901 79.1673 80.6818 79.1673H19.3182C17.5099 79.1673 15.7757 78.4844 14.497 77.2689C13.2183 76.0534 12.5 74.4048 12.5 72.6858V37.0377C12.5 35.3187 13.2183 33.6701 14.497 32.4546C15.7757 31.2391 17.5099 30.5562 19.3182 30.5562H32.9545L39.7727 20.834H60.2273L67.0455 30.5562H80.6818C82.4901 30.5562 84.2243 31.2391 85.503 32.4546C86.7817 33.6701 87.5 35.3187 87.5 37.0377V72.6858Z",
    stroke: "#939393",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 66.666C56.9036 66.666 62.5 61.0696 62.5 54.166C62.5 47.2625 56.9036 41.666 50 41.666C43.0964 41.666 37.5 47.2625 37.5 54.166C37.5 61.0696 43.0964 66.666 50 66.666Z",
    stroke: "#939393",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.2e69f93550f6ea2dc56e4f2c5cb8d304.svg";
export { ForwardRef as ReactComponent };